export const TERMS_AND_CONDITIONS_URL = 'https://www.careersandenterprise.co.uk/educators/digital-products-and-resources/digital-products-terms-and-conditions/';
export const PRIVACY_NOTICE_URL = 'https://www.careersandenterprise.co.uk/cec-privacy-notice-cookies/';
export const CONTACT_HELP_CENTER_URL = 'https://careersandenterprise.zendesk.com/hc/en-gb/requests/new';
